<template>
  <div>
    <digital></digital>
  </div>
</template>

<script>
import digital from '@views/appletManagement/digital-relics'
export default {
  data() {
    return {
      
    };
  },
  components:{
    digital
  },

  mounted() {
    
  },

  methods: {
    
  },
};
</script>

<style lang="scss" scoped>

</style>